import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const DocumentPreview = ({ content }) => {
  const paperStyles = {
    border: '1px solid var(--succession-border)',
    borderRadius: '2px',
    padding: '0.75rem',
    maxWidth: '48rem',
    margin: '0 auto',
    backgroundColor: 'var(--succession-bg-secondary)',
    backgroundImage: 'linear-gradient(var(--succession-bg-tertiary) 1px, transparent 1px)',
    backgroundSize: '100% 28px',
    position: 'relative',
    boxShadow: 'var(--succession-shadow-md)'
  };

  const redLineStyles = {
    content: '',
    position: 'absolute',
    left: '30px',
    top: 0,
    bottom: 0,
    width: '1px',
    backgroundColor: 'rgba(255,0,0,0.1)',
    height: '100%'
  };

  const contentStyles = {
    fontFamily: 'Times New Roman, serif',
    color: 'var(--succession-text-primary)',
    lineHeight: '1.5',
    padding: '0.5rem 0.75rem'
  };

  const headingStyles = {
    fontFamily: 'Times New Roman, serif',
    fontWeight: 'bold'
  };

  const tableStyles = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    marginBottom: '20px'
  };

  const tableCellStyles = {
    padding: '8px',
    borderBottom: '1px solid var(--succession-border)',
    textAlign: 'left'
  };

  return (
    <div className="p-4">
      <div style={paperStyles}>
        <div style={redLineStyles}></div>
        <div 
          className="prose max-w-none" 
          style={contentStyles}
        >
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              h1: ({node, ...props}) => <h1 style={{...headingStyles, fontSize: '24px', borderBottom: '1px solid var(--succession-border)', paddingBottom: '8px', marginBottom: '16px'}} {...props} />,
              h2: ({node, ...props}) => <h2 style={{...headingStyles, fontSize: '20px', marginTop: '24px', marginBottom: '12px'}} {...props} />,
              h3: ({node, ...props}) => <h3 style={{...headingStyles, fontSize: '18px', marginTop: '16px', marginBottom: '8px'}} {...props} />,
              p: ({node, ...props}) => <p style={{fontSize: '16px', marginTop: '8px', marginBottom: '8px'}} {...props} />,
              li: ({node, ...props}) => <li style={{fontSize: '16px'}} {...props} />,
              table: ({node, ...props}) => <table style={tableStyles} {...props} />,
              td: ({node, ...props}) => <td style={tableCellStyles} {...props} />,
              th: ({node, ...props}) => <th style={{...tableCellStyles, fontWeight: 'bold', borderBottom: '2px solid var(--succession-border)'}} {...props} />
            }}
          >
            {content || '# Business Catastrophe Plan\n\nStart filling out the questionnaire to generate your Business Catastrophe Plan document.'}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default DocumentPreview; 